var _g, _g2, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShineQuickComapre(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 50,
    viewBox: "0 0 380 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_14812_28127)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.55824,
    cy: 171.359,
    rx: 4.55824,
    ry: 171.359,
    transform: "matrix(-0.00131068 -0.999999 1 -0.000314281 18.4277 30.783)",
    fill: "url(#paint0_linear_14812_28127)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_14812_28127)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.1581,
    cy: 140.802,
    rx: 4.1581,
    ry: 140.802,
    transform: "matrix(-0.00131068 -0.999999 1 -0.000314281 49.6328 26.783)",
    fill: "url(#paint1_linear_14812_28127)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 104.102,
    y: 20.9783,
    width: 173.563,
    height: 2.197,
    fill: "url(#paint2_linear_14812_28127)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_14812_28127",
    x: -0.000473022,
    y: 3.19002,
    width: 379.561,
    height: 45.9618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.21117,
    result: "effect1_foregroundBlur_14812_28127"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_14812_28127",
    x: 31.2046,
    y: -0.0000457764,
    width: 318.45,
    height: 45.1614,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.21117,
    result: "effect1_foregroundBlur_14812_28127"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14812_28127",
    x1: 8.81935,
    y1: 342.427,
    x2: 8.53159,
    y2: 4.86109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00836175,
    stopColor: "#4022FA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509705,
    stopColor: "#3843E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#261494",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14812_28127",
    x1: 8.04516,
    y1: 281.366,
    x2: 7.83218,
    y2: 3.99423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00836175,
    stopColor: "#4022FA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509705,
    stopColor: "#3843E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#261494",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14812_28127",
    x1: 104.102,
    y1: 22.0768,
    x2: 277.665,
    y2: 22.0768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522498,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShineQuickComapre);
export default __webpack_public_path__ + "static/media/shineQuickComapre.0256ba3a4b8300fe14cad4688ec647ab.svg";
export { ForwardRef as ReactComponent };